<template>
  <Dialog :visible="visible" class="irinox-dialog-light plans-compare-dialog" :modal="true" 
              :closable="false" :dismissableMask="true" :style="{width: '1300px'}" :draggable="false"
              @update:visible="updateVisible" @show="show">
    
    <template #header>
      <img src="assets/irinox/icons/arrow_back.svg" @click="updateVisible(false)" :alt="$t('common.arrow_left')"/>
      <div class="plans-compare-title">{{$t('plans.compare.plus_premium.title')}}</div>
    </template>

    <div :class="['irinox-dialog-light-content','layout-content', 'p-d-flex', 'p-flex-column', 'p-ai-center']" style="gap: 10px;">
      <div class="plans-compare-subtitle">{{$t('plans.compare.plus_premium.subtitle')}}</div>
      <div class="irinox-form p-m-4">
        <div class="p-grid p-jc-center">
          <div class="p-col-12 p-md-6 p-lg-4" v-for="card in cards" :key="card.name">
            <PlanCard :details="card" :mode="card.mode" :plansMapping="plansMapping" @click:activate="handleCardActivate"/>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <!-- <div class="p-d-flex p-flex-column p-ai-center p-jc-center" style="gap: 20px;">
        <div class="plans-compare-disclaimer">{{$t('plans.compare.plus_premium.disclaimer1')}} <b>{{$t('plans.compare.plus_premium.disclaimer2')}}</b></div>
        <div class="plans-compare-button" @click="updateVisible(false)">{{$t('plans.compare.plus_premium.close_button')}}</div>
        <div class="plans-compare-discover" @click="buttonClick">{{$t('plans.compare.plus_premium.discover_button')}}</div>
      </div> -->
    </template>
  </Dialog>
</template>

<script>
import PlanCard from './PlanCard.vue';
export default {
    emits: ['update:visible', 'click:activate'],
    components: {
      PlanCard
    },
    props: {
      visible: Boolean,
      plans: Array,
      plansMapping: Object
    },
    data() {
        return {
          cards: []
        };
    },
    computed: {
      getPlusPlan() {
        return this.plans.find(plan => plan.code === 'PLUS');
      },
      getPremiumPlan() {
        return this.plans.find(plan => plan.code === 'PREMIUM');
      },
    },
    watch: {
      'plans': 'loadCards'
    },
    created() {
    },
    mounted() {
      this.loadCards();
    },
    methods: {
      loadCards() {
        this.cards = [
          {
              mode: 'compare',
              class: 'premium',
              // badges: [{name: this.$t('plans.compare.plus_premium.recommended'), image: null, class: 'recommended'}],
              badges: [],
              image: 'premium.svg',
              name: this.$t('plans.compare.plus_premium.premium.name'),
              title: this.getPremiumPlan?.priceCentsEur ? this.$t('plans.compare.plus_premium.premium.price', { price: this.$n(this.getPremiumPlan?.priceCentsEur / 100, 'money'), currency: '€'}) : 'N/A',
              subtitle: this.$t('plans.compare.plus_premium.premium.subtitle'),
              features: [
                {name: this.$t('plans.compare.plus_premium.premium.feature1'), image: 'plus_feature1.svg'},
                {name: this.$t('plans.compare.plus_premium.premium.feature2'), image: 'plus_feature2.svg'},
                {name: this.$t('plans.compare.plus_premium.premium.feature3'), image: 'plus_feature3.svg'},
                {name: this.$t('plans.compare.plus_premium.premium.feature4'), image: 'premium_feature2.svg'},
              ],
              events: {
                contract: null,
                activate: "PREMIUM",
                select: null,
                discover: null
              }
            },
          {
              mode: 'compare',
              class: 'plus',
              badges: [],
              image: 'plus.svg',
              name: this.$t('plans.compare.plus_premium.plus.name'),
              title: this.getPlusPlan?.priceCentsEur ? this.$t('plans.compare.plus_premium.plus.price', { price: this.$n(this.getPlusPlan?.priceCentsEur / 100, 'money'), currency: '€'}) : 'N/A',
              subtitle: this.$t('plans.compare.plus_premium.plus.subtitle'),
              features: [
                {name: this.$t('plans.compare.plus_premium.plus.feature1'), image: 'plus_feature1.svg'},
                {name: this.$t('plans.compare.plus_premium.plus.feature2'), image: 'plus_feature2.svg'},
                {name: this.$t('plans.compare.plus_premium.plus.feature3'), image: 'plus_feature3.svg'},
              ],
              events: {
                contract: null,
                activate: "PLUS",
                select: null,
                discover: null
              }
            },
            {
              mode: 'compare',
              class: 'base',
              badges: [],
              image: null,
              name: this.$t('plans.compare.plus_premium.base.name'),
              title: this.$t('plans.compare.plus_premium.base.title'),
              subtitle: null,
              features: [
                {name: this.$t('plans.compare.plus_premium.base.feature1'), image: 'base_feature1.svg'},
                {name: this.$t('plans.compare.plus_premium.base.feature2'), image: 'base_feature2.svg'},
                {name: this.$t('plans.compare.plus_premium.base.feature3'), image: 'base_feature3.svg'},
              ],
            },
            
            
          ];
      },
      updateVisible(value) {
        this.$emit("update:visible", value);
      },
      handleCardActivate(planCode) {
        this.$emit('click:activate', planCode);
        this.updateVisible(false);
      },
      buttonClick() {
        this.$window.open(this.plansMapping[this.$i18n.locale=='en-US'? 'us' : this.$i18n.locale]['plus_premium'].info, '_blank');
      },
      show() {
      },
    }
}
</script>

<style>

</style>